// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"tl-z","innerTile":"ul-z","heading":"vl-z","instaTileBtn":"wl-z","disabled":"xl-z","instaTileElement":"yl-z","instagramPic":"zl-z"};